module.exports = __webpack_public_path__ + "img/Single.8f4b2a8c.svg";